import { render, staticRenderFns } from "./training-list.vue?vue&type=template&id=7871385b&scoped=true&"
import script from "./training-list.vue?vue&type=script&lang=js&"
export * from "./training-list.vue?vue&type=script&lang=js&"
import style0 from "./training-list.vue?vue&type=style&index=0&id=7871385b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7871385b",
  null
  
)

export default component.exports